import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { useRouter } from "next/navigation";
import ConfirmationModal from "./ConfirmationModal";
import useSubscriptionStore from "../store/subscriptionStore";
import { useTranslation } from "../../../i18n/client";
const SubscriptionWarningModal = (param)=>{
    let { open, onClose, lng, context = "default" } = param;
    const router = useRouter();
    const { t } = useTranslation(lng, "invoices-page");
    const { isExpired, plan, daysLeft, invoicesRemaining, canCreateInvoice, duration } = useSubscriptionStore();
    const handleUpgradePlan = ()=>{
        onClose();
        router.push("/application/myaccount?tab=my-plan");
    };
    // Determine the appropriate message based on subscription status
    const getWarningContent = ()=>{
        if (isExpired) {
            return {
                title: t("subscriptionExpired"),
                subtitle: context === "xrechnung" ? t("subscriptionExpiredXRechnungMessage") : t("subscriptionExpiredMessage"),
                primaryBtnName: t("upgradePlan"),
                primaryBtnAction: handleUpgradePlan,
                secondaryBtnName: t("cancel"),
                secondaryBtnAction: onClose
            };
        } else if (!canCreateInvoice && invoicesRemaining === 0) {
            // Check if user has an active yearly plan
            if (duration && duration.toLowerCase().includes("year") && !isExpired) {
                return {
                    title: t("monthlyLimitReached"),
                    subtitle: t("monthlyLimitReachedYearlyPlanMessage"),
                    primaryBtnName: t("ok"),
                    primaryBtnAction: onClose,
                    secondaryBtnName: undefined,
                    secondaryBtnAction: undefined
                };
            } else {
                return {
                    title: t("upgradePlan"),
                    subtitle: t("invoiceLimitReachedMessage"),
                    primaryBtnName: t("upgradePlan"),
                    primaryBtnAction: handleUpgradePlan,
                    secondaryBtnName: t("cancel"),
                    secondaryBtnAction: onClose
                };
            }
        } else if (plan === "Free" && !isExpired) {
            return {
                title: t("freeTrialExpiring"),
                subtitle: t("freeTrialExpiringMessage", {
                    daysLeft
                }),
                primaryBtnName: t("upgradePlan"),
                primaryBtnAction: handleUpgradePlan,
                secondaryBtnName: t("cancel"),
                secondaryBtnAction: onClose
            };
        }
        // Default fallback
        return {
            title: t("subscriptionIssue"),
            subtitle: t("subscriptionIssueMessage"),
            primaryBtnName: t("upgradePlan"),
            primaryBtnAction: handleUpgradePlan,
            secondaryBtnName: t("cancel"),
            secondaryBtnAction: onClose
        };
    };
    const content = getWarningContent();
    return /*#__PURE__*/ _jsx(ConfirmationModal, {
        open: open,
        handleClose: onClose,
        title: content.title,
        subtitle: content.subtitle,
        primaryBtnName: content.primaryBtnName,
        primaryBtnAction: content.primaryBtnAction,
        secondaryBtnName: content.secondaryBtnName,
        secondaryBtnAction: content.secondaryBtnAction
    });
};
export default SubscriptionWarningModal;
